import { RunScenarioInput } from 'views/playground/features/bluviu-nutrition-r2/types/run-scenario-input.type';

export const runScenario = (request: RunScenarioInput): Promise<string> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve('200');
    }, 3000); // 3-second delay
  });
};
